import React, { Fragment, useEffect, useState, useRef } from 'react';
import { scrollTo } from '../../utils';


const DateItem = (props) => {
    const {
        date = null,
        gameCount = "1",
        current = false,
        onClick = () => {},
        ...restProps
    } = props;
    if ( !date ) return;
    const buttonRef = useRef(null);

    // Set up game count string
    let gameCountStr = gameCount > 1 ? gameCount + ' Games' : gameCount + ' Game';

    // Set up classes
    let classes = "acaDateItem";
    if ( current ) classes += ' acaDateItem--current';

    // Set up date pieces
    const weekday = date.toLocaleString("default", { weekday: "short", timeZone: 'UTC' });
    const day = date.toLocaleString("default", { day: "numeric", timeZone: 'UTC' });

    // Scroll to the current date
    if (current && buttonRef.current) {
        buttonRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center'
          });
    }

    return (
        <button ref={buttonRef} onClick={onClick} className={classes}>
            <div className="acaH3 acaDateItem__weekday">{weekday}</div>
            <div className="acaH1 acaDateItem__day">{day}</div>
            <div className="acaH5--alt acaDateItem__gameCount">{gameCountStr}</div>
        </button>
    );

}

const DateMonth = (props) => {
    const {
        month = null,
        ...restProps
    } = props;

    return (
        <div className="acaDateMonth">
            <div className="acaH5--alt acaDateMonth__inner">{month}</div>
        </div>
    );

}


const DateGrid = (props) => {
    const { 
        dates   = null,
        children = null,
        onChange = (date) => {},
        ...restProps 
    } = props;

    const [ dateObjs, setDateObjs ] = useState(null);
    const [ currentDate, setCurrentDate ] = useState(null);

    /**
     * When the date list changes:
     * 1- Update the list of date objects
     * 2- Update the default current date
     */
    useEffect(() => {
        if ( !dates ) return;

        // Set up an array of date objects
        let dateObjsArray = [];
        Object.keys(dates).map((keyName, i) => {
            // Add a time of midnight and website UTC offset before converting to date object
            const dateString = keyName.replace(/-/g, "/") + ' 00:00 ' + acaTimezoneOffset;

            // Add to array
            dateObjsArray.push({
                date: new Date(dateString),
                gameCount: dates[keyName]
            });
        })
        setDateObjs(dateObjsArray);

        // Check if there's an upcoming date to set as current
        const today = new Date();
        const nextDateIndex = dateObjsArray.findIndex((element) => sameDay(element.date, today) || element.date > today);
        let newCurrentIndex;
        if ( nextDateIndex > -1 ) {
            newCurrentIndex = nextDateIndex;
        } else {
            // Else, set the last date in the schedule as the current day
            newCurrentIndex = dateObjsArray.length - 1;
        }
        setCurrentDate(newCurrentIndex);

    }, [dates]);

    // When the current selected date changes, call the change event
    useEffect(() => {
        if ( currentDate == null ) return;
        onChange(dateObjs[currentDate].date);
    }, [currentDate]);

    // Check if 2 dates are the same
    function sameDay(d1, d2) {
        return d1.getFullYear() === d2.getFullYear() &&
          d1.getMonth() === d2.getMonth() &&
          d1.getDate() === d2.getDate();
    }

    // Check if we should display a month item
    let currentMonth = '';
    function checkForMonth(date) {
        let month = date.toLocaleString("default", { month: "long", timeZone: acaTimezone });
        if ( currentMonth == month ) {
            return false;
        } else {
            currentMonth = month;
            return true;
        }
    }

    return (
        <div className="acaDateGrid__wrapper">
            <div className="acaDateGrid">

                { dateObjs ? (
                    dateObjs.map((obj, i) => (
                        <Fragment key={i}>
                            { checkForMonth(obj.date) ? (
                                <DateMonth month={currentMonth} />
                            ) : '' }
                            <DateItem onClick={() => setCurrentDate(i)} date={obj.date} gameCount={obj.gameCount} current={i == currentDate ? true : false} />
                        </Fragment>
                    ))
                ) : '' }

            </div>
        </div>
    );

}



/**
 * Export
 */
export { DateGrid };